export const SUBMIT_SANTA_SIGNUP_FORM = 'SUBMIT_SANTA_SIGNUP_FORM';
export const FETCH_SANTA_AVAILABLE_TIMESLOTS = 'FETCH_SANTA_AVAILABLE_TIMESLOTS';
export const STORE_SANTA_AVAILABLE_TIMESLOTS = 'STORE_SANTA_AVAILABLE_TIMESLOTS';
export const SET_SANTA_TIMESLOT_TIMEZONE = 'SET_SANTA_TIMESLOT_TIMEZONE';
export const STORE_RESERVATION_WAS_SUCCESSFULLY_BOOKED = 'STORE_RESERVATION_WAS_SUCCESSFULLY_BOOKED';
export const STORE_REVERATION_WAS_UNSUCCESSFUL = 'STORE_REVERATION_WAS_UNSUCCESSFUL';
export const STORE_SANTA_API_RETURNED_UNEXPECTED = 'STORE_SANTA_API_RETURNED_UNEXPECTED';
export const ON_SANTA_PAGE_LOADED = 'ON_SANTA_PAGE_LOADED';
export const ON_HAD_SANTA_FORM_SUBMISSION_STATUS = 'ON_HAD_SANTA_FORM_SUBMISSION_STATUS';
export const CLEAR_SANTA_ERROR = 'CLEAR_SANTA_ERROR';
